var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b5aa3",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2ae57",
    d: "M0 39 53.3 0v7.3L0 40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1.9 40 51.4-25V7L0 40zM14.6 1.3l-.5 8.5-2.3-5.4.9 5.8-3.5-4.7 2.3 5.3-4.6-3.5 3.6 4.5-5.2-2.3 4.5 3.4-5.6-.8 5.3 2.2-8.3.7 8.4.6-5.4 2.2 5.6-.8-4.5 3.4 5.3-2.3L7 22.5l4.5-3.4-2.2 5.3 3.6-4.6-1 5.7 2.3-5.3.5 8.4.8-8.4 2 5.3-.7-5.7 3.6 4.5L18 19l4.5 3.7L19 18l5.4 2.2-4.7-3.4 5.8 1-5.6-2.2 8.7-.5-8.7-.9 5.7-1.9-6 .8 5-3.4L19 12l3.8-4.6L18 11l2.3-5.5-3.6 4.7.8-6-2.2 5.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMh);
export default __webpack_public_path__ + "static/media/mh.2fdbacc4d487ee249b8f2026fba99cef.svg";
export { ForwardRef as ReactComponent };